export const findIndexWrapAround = (currentIndex: number, length: number, offset: number) =>
  (currentIndex + offset + length) % length;
